module.exports = __webpack_public_path__ + "static/media/breadcrumb-arrow.3d8b9aaf.svg";